<div *ngIf="!isLoading && !hasSchedulers" class="info-message" i18n="@@operating.scheduler.message.noschedulersavailable">No schedulers available</div>
<ng-container *ngIf="hasSchedulers">
    <div class="button-bar">
        <messages name="scheduler-save-message" class="show-inline with-icon"></messages>
        <clx-button type="save" [state]="saveState" test-id="scheduler.save.button" title="Save" i18n="@@operating.scheduler.button.save" i18n-title="@@operating.scheduler.button.save" (click)="save()" [disabled]="!schedulers || isSaving ? true : null">Save</clx-button>
    </div>
</ng-container>
<div class="ba-widgets" scheduler-templates [hidden]="!hasSchedulers">
    <!--<div #loading-area></div>-->
    <div #schedulers>
        <div id="nav-area"></div>
        <div id="work-area">
            <div id="work-view">
                <div id="workcontent-view" class="">
                    <div id="scheduler-overview">
                    </div>
                </div>
            </div>
            <div id="tools-area" class="hidden"></div>
        </div>
    </div>
</div>
